import initialState from './state'
import { dealTableFields } from '@/utils/formSettingTransfor'

const dealAppDeatil = (state, detail) => {
  if (!detail) {
    return state
  }
  for (const k in state.app.detail) {
    if (k in detail) {
      state.app.detail[k] = detail[k]
    }
  }
  return state
}

const setvalueForTipsconfig = (state, config) => {
  if (!config) {
    return state
  }
  for (const k in config) {
    if (k in state.tipsConfig) {
      state.tipsConfig[k] = config[k]
    }
  }
  return state
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'setLanguage':
      state.language = action.data
      return state
    case 'tableList':
      state.formSetting.tableList = action.data
      return state
    case 'recordTableFields':
      state.formSetting.fieldsObj[action.tableKey] = dealTableFields(action.data, state.language)
      return state
    case 'recordTableValues':
      state.formSetting.fieldsValues[action.tableKey] = Array.isArray(action.data) ? action.data : []
      return state
    case 'setOrgId':
      state.orgId = action.orgId
      return state
    case 'setUserInfo':
      state.userInfo = action.userInfo
      return state
    case 'setShareList':
      state.formSetting.shareDataObj[action.tableKey] = Array.isArray(action.data) ? action.data : []
      return state
    case 'setAttendeeSubmitRecord':
      if (Array.isArray(action.data)) {
        action.data.forEach(item => {
          state.attendeeSubmitRecord.records.push({
            id: item.pkey,
            name: item.relationUserName,
            createdDate: item.createdDate,
            avatar: item.avatar,
            status: item.auditStatus,
            statusName: item.auditStatusName,
            message: item.auditMessage,
            contents: item.contents,
            ...item
          })
        })
      }
      return { ...state }
    case 'setAttendeeSubmitPager':
      if (action.data.totalCount) {
        state.attendeeSubmitRecord.total = action.data.totalCount
      }
      if (action.data.totalPage) {
        state.attendeeSubmitRecord.totalPage = action.data.totalPage
      }
      return state
    case 'setAppDetail':
      return dealAppDeatil(state, action.data)
    case 'initAttendeeSubmitRecord':
      state.attendeeSubmitRecord.records = []
      return state
    case 'setSameToken':
      state.st = action.data
      return state
    case 'setAssociatedTable':
      state.associatedTable.have = action.have
      state.associatedTable.apiInfo = action.apiInfo
      state.associatedTable.fields = action.fields
      return state
    case 'setTipsconfig':
      return setvalueForTipsconfig(state, action.data)
    case 'setFormTheme':
      return { ...state, formTheme: action.data }
    case 'setBventId':
      state.associatedBventId = action.bventId
      return state
    case 'setChannelForm':
      state.channelForm = {
        paper: action.paper,
        firstAuthor: action.firstAuthor,
        otherAuthor: action.otherAuthor
      }
      return state
    case 'setChannelDetail':
      state.channelDetail = action.data
      return state
    case 'setRelationId':
      state.relationId = action.data
      return state
    default:
      return state
  }
}
